module.exports = __webpack_public_path__ + "img/shareInfo.e1666090.png";